// A remote image's load state, as the art that shows it tracks it: shared by
// the components that render remote art and the reveal predicate that waits
// on hero banners (GLOSSARY.md "Reveal surface").
export type RemoteArtworkStatus = 'failed' | 'loaded' | 'loading'

// The one rule for what counts as a loadable remote image URL — shared by
// every collection whose art is a backend URL rather than a native asset
// (currency packs, land skins; ADR 0013). null marks a URL Shop must treat as
// absent: empty, unparseable, or on a scheme the browser will not fetch as an
// image from a WebView.
export function validRemoteImageUrl(value: unknown): string | null {
  if (typeof value !== 'string' || value.length === 0) return null
  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:' ? value : null
  } catch {
    return null
  }
}
